import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { DiarioEmocionesGuard } from './core/guards/diario-emociones.guard';
import { Page404Component } from './extrapages/page404/page404.component';

const routes: Routes = [
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard], canActivateChild: [DiarioEmocionesGuard] },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule), canActivate: [AuthGuard] },
  { path: 'account', redirectTo: 'account/login', pathMatch: 'full' },
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: '**', component: Page404Component } //PÁGINA NO ENCONTRADA
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top',anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
